import { Component, OnInit } from '@angular/core';
import { ConfirmState } from 'src/app/shared/dialogs/models/ConfirmState';
import { MsgOptions } from 'src/app/shared/dialogs/models/MsgOptions';

@Component({
  selector: 'app-primitive-modal',
  templateUrl: './primitive-modal.component.html',
  styleUrls: ['./primitive-modal.component.scss']
})
export class PrimitiveModalComponent implements OnInit {
  options: MsgOptions;

  constructor(private state: ConfirmState) {
    this.options = state.options;
  }

  ngOnInit(): void {
  }

  close() {
    this.state.modal.dismiss();
  }

}
